import { forwardRef, Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { DependencyTreeCanActivate } from 'app/core/guards/dependency-tree.guard';
// import { AuthenticationGuard } from 'app/core/services/adal/authenticated.guard';
import { SessionState } from 'app/core/store/session/session.interface';
import { logger } from 'app/core/util/logger';
import { Observable } from 'rxjs';
import * as fromRoot from 'app/core/store';
import { appSettings } from 'app/appSettings';
import { goAction } from '../store/router/router.actions';
import { map } from 'rxjs/operators';
import { AuthenticatedGuard } from './authenticated.guard';
import { ComesFromLaunchpadGuard } from 'app/core/guards/comes-from-launchpad.guard';

/**
 * Guard that customer is selected
 */
@Injectable({ providedIn: 'root' })
export class NotSelectedCustomerGuard implements CanActivate, DependencyTreeCanActivate {
  private store: Store<fromRoot.RootState>;

  constructor(@Inject(forwardRef(() => Store)) store) {
    this.store = store;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    logger.debug('In NotSelectedCustomerGuard');
    return this.store.select('session').pipe(
      map((session: SessionState) => {
        const hasSelectedCustomer = !!(session.selectedCustomer.data?.id);
        if (hasSelectedCustomer) {
          this.store.dispatch(goAction({ path: appSettings.DEFAULT_ROUTE }));
        }
        return !hasSelectedCustomer;
      })
    );
  }

  getDependencies(): any {
    return [AuthenticatedGuard, ComesFromLaunchpadGuard];
  }

  getDependencyRouteData(): any {}
}
